import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-sm max-w-none" data-id="element-753">
      <p className="text-gray-600 mb-4" data-id="element-754">
        <strong data-id="element-755">Última actualización:</strong> Enero
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-756">
        1. Información que Recopilamos
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-757">
        Recopilamos información que nos proporcionas directamente cuando:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-758">
        <li data-id="element-759">Compras nuestro sistema de recetas</li>
        <li data-id="element-760">Te suscribes a nuestro newsletter</li>
        <li data-id="element-761">Nos contactas para soporte</li>
        <li data-id="element-762">Participas en nuestra comunidad</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-763">2. Uso de la Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-764">Utilizamos tu información para:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-765">
        <li data-id="element-766">Procesar tus compras y enviarte el contenido digital</li>
        <li data-id="element-767">Enviarte actualizaciones del producto y recetas nuevas</li>
        <li data-id="element-768">Responder a tus consultas y brindarte soporte</li>
        <li data-id="element-769">Mejorar nuestros productos y servicios</li>
        <li data-id="element-770">Cumplir con obligaciones legales</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-771">3. Protección de Datos</h3>
      <p className="text-gray-700 mb-4" data-id="element-772">
        Implementamos medidas de seguridad para proteger tu información
        personal:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-773">
        <li data-id="element-774">Encriptación SSL en todas las transacciones</li>
        <li data-id="element-775">Servidores seguros y protegidos</li>
        <li data-id="element-776">Acceso limitado a información personal</li>
        <li data-id="element-777">Cumplimiento con GDPR y regulaciones internacionales</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-778">4. Cookies</h3>
      <p className="text-gray-700 mb-4" data-id="element-779">
        Utilizamos cookies para mejorar tu experiencia en nuestro sitio. Puedes
        configurar tu navegador para rechazar cookies, aunque esto puede afectar
        algunas funcionalidades del sitio.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-780">5. Compartir Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-781">
        No vendemos ni compartimos tu información personal con terceros,
        excepto:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-782">
        <li data-id="element-783">Procesadores de pago necesarios para completar transacciones</li>
        <li data-id="element-784">
          Proveedores de servicios que nos ayudan a operar nuestro negocio
        </li>
        <li data-id="element-785">Cuando sea requerido por ley</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-786">6. Tus Derechos</h3>
      <p className="text-gray-700 mb-4" data-id="element-787">Tienes derecho a:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-788">
        <li data-id="element-789">Acceder a tu información personal</li>
        <li data-id="element-790">Corregir información incorrecta</li>
        <li data-id="element-791">Solicitar la eliminación de tus datos</li>
        <li data-id="element-792">Cancelar suscripciones en cualquier momento</li>
        <li data-id="element-793">Presentar una queja ante autoridades de protección de datos</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-794">7. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-795">
        Para cualquier consulta sobre esta política de privacidad, contáctanos
        a:
        <br data-id="element-796" />
        <strong data-id="element-797">Email:</strong>{' '}
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-798">
          contactomikioscodigital@gmail.com
        </a>
      </p>
    </div>;
}